const ResourceProducts = [
    {
      category: "Mega Bundle",
      courses: [
        {
          name: "500+ GB Editing Assets",
          link: "https://t.me/c/2270190947/5828/32531",
        },
        {
          name: "22 TB BIG COLLECTION PREMIUM COURSE",
          link: "https://t.me/c/2270190947/5828/35962",
        },
        {
          name: "ALL MONEY MAKING COURSES 2 TB",
          link: "https://t.me/c/2270190947/5828/35961",
        },
        {
          name: "The Ultimate Green Screen Effects Pack ",
          link: "https://t.me/c/2270190947/5828/33680",
        },
        {
          name: "1000+ FREE Animated Emojis! 👑",
          link: "https://t.me/c/2270190947/5828/33679",
        },
        {
          name: "free animated characters bundle 💰",
          link: "https://t.me/c/2270190947/5828/33678",
        },
        {
          name: "🔥 Free Editing Pack ⁉️ FACELESS PNG PACK  🔥",
          link: "https://t.me/c/2270190947/5828/33677",
        },
        {
          name: "All Types of Campus Placement Materials",
          link: "https://t.me/c/2270190947/5828/33049",
        },
        {
          name: "75 Premium Shopify Themes",
          link: "https://t.me/c/2270190947/5828/32513",
        },
        {
          name: "5000+ Premium Canva Editable Templates",
          link: "https://t.me/c/2270190947/5828/32643",
        },
        {
          name: "1200+ Emotional reels Bundle",
          link: "https://t.me/c/2270190947/9431/9432",
        },
        {
          name: "Huge Islamic Reels Bundle",
          link: "https://t.me/c/2270190947/9431/10846",
        },
        {
          name: "4000+ MOTIVATIONAL REELS BUNDLE",
          link: "https://t.me/c/2270190947/9431/32644",
        },
        {
          name: "1200+ CANVA EDITABLE TEMPLATE",
          link: "https://t.me/c/2270190947/5828/32645",
        },
        {
          name: "GYM REELS BUNDLE",
          link: "https://t.me/c/2270190947/9431/32646",
        },
        {
          name: "CHAT GPT PROMPTS",
          link: "https://t.me/c/2270190947/9431/32647",
        },
        {
          name: "GRAPHICS BUNDLE",
          link: "https://t.me/c/2270190947/5828/32648",
        },
        {
          name: "1000+ DIGITAL PRODUCT BUNDLE",
          link: "https://t.me/c/2270190947/5828/32649",
        },
        {
          name: "LANDING PAGE BUNDLE",
          link: "https://t.me/c/2270190947/5828/32650",
        },
        {
          name: "200+ Cricket Reels",
          link: "https://t.me/c/2270190947/5828/32650",
        },
        {
          name: "500+ Different AI Reels Bundle",
          link: "https://t.me/c/2270190947/9431/25581",
        },
        {
          name: "4000+ Viral Reels Bundle",
          link: "https://t.me/c/2270190947/9431/25580",
        },
        {
          name: "AI Health Reels Bundle",
          link: "https://t.me/c/2270190947/9431/25579",
        },
        {
          name: "Instagram English Reels",
          link: "https://t.me/c/2270190947/9431/25578",
        },
        {
          name: "NATURAL SHORTS REEL BUNDLE",
          link: "https://t.me/c/2270190947/9431/25576",
        },
        {
          name: "Enhance Your Creativity with Glowing Icon ",
          link: "https://t.me/c/2270190947/9431/25575",
        },
        {
          name: "MAFIA CARS SHORTS BUNDLE  ",
          link: "https://t.me/c/2270190947/9431/25574",
        },
        {
          name: "1400+ Hindi Motivational Reels Bundle ",
          link: "https://t.me/c/2270190947/9431/25573",
        },
        {
          name: "3000+ Mega Anime Edits Reel Bundle 📱",
          link: "https://t.me/c/2270190947/9431/17968",
        },
        {
          name: "AI MOTIVATIONAL REELS BUNDLE ",
          link: "https://t.me/c/2270190947/9431/17964",
        },
        {
          name: "Social Media Assets + Digital Planner + Journal Tracker + T-Shirt Design + Ebooks + Shopify Themes",
          link: "https://t.me/c/2270190947/5828/32652",
        },
        {
          name: "ENVATO GRAPHIC BUNDLE 😡",
          link: "https://t.me/c/2270190947/9433/17927",
        },
        {
          name: "2TB Editing Pack",
          link: "https://t.me/c/2270190947/5828/32728",
        },
        {
          name: "500+ Premium Sound Effects (2025)",
          link: "https://t.me/c/2270190947/5828/32731",
        },
        {
          name: "The Ultimate Super AI Automations Bundle",
          link: "https://t.me/c/2270190947/5828/32733",
        },
        {
          name: "100,000+ T-Shirt Designs",
          link: "https://t.me/c/2270190947/5828/32752",
        },
        {
          name: "30,000+ Social Media Posts",
          link: "https://t.me/c/2270190947/5828/32753",
        },
        {
          name: "25,000+ Premium Fonts",
          link: "https://t.me/c/2270190947/5828/32754",
        },
        {
          name: "100+ Premium Shopify Themes",
          link: "https://t.me/c/2270190947/5828/32755",
        },
        {
          name: "Sales Message Script, Templates",
          link: "https://t.me/c/2270190947/5828/32756",
        },
        {
          name: "15000+ ChatGPT Prompts",
          link: "https://t.me/c/2270190947/5828/32764",
        },
        {
          name: "Wedding Invitation Cards",
          link: "https://t.me/c/2270190947/5828/32763",
        },
        {
          name: "All Companies Paid Placement Material",
          link: "https://t.me/c/2270190947/5828/32993",
        },
        {
          name: "Special Video editing Pack",
          link: "https://t.me/c/2270190947/5828/33021",
        },
        {
          name: "🌟 *15,000+ ChatGPT Prompts Bundle By Courses hi Courses",
          link: "https://t.me/c/2270190947/5828/36897",
        },
        {
          name: "700 GB+ Graphic Collection",
          link: "https://t.me/c/2270190947/5828/36825",
        },
       
      ],
    },
]
export default ResourceProducts;